import { DiagnoseDetailPanelComponent } from './DiagnoseDetail/DiagnoseDetailPanelComponent';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AppViewReceiverConst } from 'src/app/Util/AppReceiver/AppViewReceiverConst';
import { BaseFragment } from 'src/app/View/BaseUI/BaseFragment';
import { AppViewReceiverModel } from 'src/app/Util/AppReceiver/AppViewReceiverModel';
import { DiagnoseFragmentController } from './DiagnoseFragmentController';
import { GuestUserService } from "../../../../../Service/GuestUserService";

/**
 * DiagnoseFragmentComponent
 * 検査結果一覧画面
 */
@Component({
	selector: 'app-diagnose-component',
	templateUrl: './DiagnoseFragmentComponent.html',
	styleUrls: ['./DiagnoseFragmentComponent.scss'],
})
export class DiagnoseFragmentComponent extends BaseFragment {

	// イベント設定
	private TARGET_CLASS_DEF = AppViewReceiverConst.User.Fragment.DiagnoseFragmentComponent;
	protected EVENT_LIST: Array<Array<any>> = [
		// 画面遷移用イベント。BaseFragmentに実装されているメソッドなので注意
		// スライドイン呼び出し
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.ChangeMovePanelView,
			this.changeMovePanelView.bind(this)
		],
		// スライドインした時に消えた前パネルを戻す
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.VisiblePanelView,
			this.visibleAllViewRef.bind(this)
		],
		// スライドインを閉じる
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.CloseMovePanelView,
			this.closeMovePanelView.bind(this)
		]
	];

	// スライドイン用のコンポーネント
	@ViewChild('slideMoveBaseContainer', { read: ViewContainerRef, static: false })
	public slideMoveBaseRef: ViewContainerRef;

	// 紐付いたコントローラー
	public combineCtrl: DiagnoseFragmentController;

	// 元のPDFファイルのリスト
	public orgLstData = [];
	// PDFファイルのリスト
	public lstData = [];
	// リストの表示期間
	public showTerm = '1';

	/**
	 * constructor
	 */
	constructor() {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// EVENT_LISTに定義したイベントを登録する。
		this.registerEvent();

		// コントローラーの生成
		this.createController(DiagnoseFragmentController);
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// 検査結果一覧を取得
		const ret = await this.execFuncWithErrorHandling(this,
			this.combineCtrl.getDiagnoseList.bind(this),
			{ view: this }
		);
		if (ret) {
			this.orgLstData = ret;
			// 表示期間によって表示用リストを変更する
			this.lstData = this.dispatchDiagnoseTerm(this.orgLstData);
		}

	}

	/////////////////////////////////////
	// 画面イベント
	/**
	 * onClickShowPasswordSettingPanel
	 * ライン連携設定表示ボタンを謳歌したときのイベント
	 */
	public async onClickShowDiagnoseDetail(data: any) {

		this.log(data);

		// スライドインで表示する。
		const inst = await this.changeMovePanelView(this, [DiagnoseDetailPanelComponent, data]) as DiagnoseDetailPanelComponent;

		// 作ったインスタンスに、アニメーションコールバック用のモデルをセット
		const targetDomain = AppViewReceiverConst.User.Fragment;
		const targetName = targetDomain.DiagnoseFragmentComponent;
		const eventTargetModel = new AppViewReceiverModel(targetDomain, targetName, targetName.ChangeMovePanelView, this);
		inst.animationParentEventModel = eventTargetModel;

	}

	/**
	 * 表示期間変更イベント
	 * １ヶ月、６ヶ月、全期間で表示を分ける
	 */
	public onChangeSelectedTerm() {

		this.lstData = this.dispatchDiagnoseTerm(this.orgLstData);

	}



	/**
	 * dispatchDiagnoseTerm
	 * 検査一覧の表示期間を変更して、表示するデータを絞り込む
	 * @param lst 元のデータリスト
	 * @returns 絞り込んだデータリスト
	 */
	private dispatchDiagnoseTerm(lst: Array<any>) {

		const dist = lst.filter(val => {

			const diagnoseDate = new Date(val.date);
			const today = new Date();

			if (this.showTerm === '1') {
				return diagnoseDate.getFullYear() === today.getFullYear() &&
					diagnoseDate.getMonth() >= today.getMonth() - 1;
			}
			if (this.showTerm === '2') {
				return diagnoseDate.getFullYear() === today.getFullYear() &&
					diagnoseDate.getMonth() >= today.getMonth() - 6;
			}
			if (this.showTerm === '3') {
				return val;
			}

		});

		return dist;

	}


}

